/* eslint-disable consistent-return */
class QualiopiApi {
  // Charge tout en un appel : profil OF (nom + flags), évaluations, preuves.
  async getState(accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/qualiopi/state`;
    const resp = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const json = await resp.json();
    return Promise.resolve(json.data);
  }

  // Flags de profil (CFA / certifiant) — écrits immédiatement, recalcul du périmètre.
  async setProfile(estCfa, estCertifiant, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/qualiopi/profile`;
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ est_cfa: estCfa, est_certifiant: estCertifiant }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return await resp.json();
  }

  // Upsert du statut d'un indicateur (horodate date_verif = maintenant côté serveur).
  async setStatut(indicateurId, statut, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/qualiopi/statut`;
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ indicateur_id: indicateurId, statut }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return await resp.json();
  }

  // Upsert des notes (préserve le statut existant, ne touche pas date_verif).
  async setNotes(indicateurId, notes, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/qualiopi/notes`;
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ indicateur_id: indicateurId, notes }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return await resp.json();
  }

  // Ajout d'une preuve de type URL.
  async addPreuveUrl(indicateurId, nom, urlValue, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/qualiopi/preuve-url`;
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ indicateur_id: indicateurId, nom, url: urlValue }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return await resp.json();
  }

  // Téléversement d'un fichier preuve (multipart). Le serveur crée l'éval si besoin (ensureEval).
  async uploadPreuve(indicateurId, file, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/qualiopi/preuve-upload`;
    const data = new FormData();
    data.append("indicateur_id", indicateurId);
    data.append("file", file);
    const resp = await fetch(url, {
      method: "POST",
      body: data,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return await resp.json();
  }

  // Suppression d'une preuve (ligne DB puis fichier).
  async deletePreuve(preuveId, accessToken) {
    const url = `${process.env.REACT_APP_API_URL}/api/qualiopi/preuve-delete`;
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ preuve_id: preuveId }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return await resp.json();
  }

  // URL de téléchargement d'un fichier preuve (le bucket est privé côté serveur).
  downloadPreuveUrl(preuveId) {
    return `${process.env.REACT_APP_API_URL}/api/qualiopi/preuve-download/${preuveId}`;
  }
}

export const qualiopiApi = new QualiopiApi();
